// StockList.js

// import React, { useContext } from "react";
// import { WebSocketContext } from "./WebSocketContext";

// const StockList = () => {
//   const { stocks, lastUpdateTime } = useContext(WebSocketContext);

//   return (
//     <div>
//       <h1>Stock List</h1>
//       <p>Last Update: {lastUpdateTime?.toLocaleString()}</p>
//       <ul>
//         {stocks.map((stock, index) => (
//           <li key={index}>
//             {/* Render your stock data here */}
//             {stock.symbol}: {stock.price}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default StockList;


// import React, { useContext } from "react";
// import { WebSocketContext } from "./WebSocketContext";

// const StockList = () => {
//   const { stocks, lastUpdateTime } = useContext(WebSocketContext);

//   return (
//     <div>
//       <h2>Stock List</h2>
//       <p>Last Update: {lastUpdateTime ? lastUpdateTime.toLocaleString() : "N/A"}</p>
//       <ul>
//         {stocks.map((stock, index) => (
//           <li key={index}>
//             {JSON.stringify(stock)}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default StockList;


// import React, { useContext } from "react";
// import { WebSocketContext } from "./WebSocketContext";

// const StockList = () => {
//   const { stocks, lastUpdateTime } = useContext(WebSocketContext);

//   return (
//     <div>
//       <h2>Stock List</h2>
//       <p>Last Update: {lastUpdateTime ? lastUpdateTime.toLocaleString() : "N/A"}</p>
//       <ul>
//         {Object.values(stocks).map((stock) => (
//           <li key={stock.Symbol}>
//             Symbol: {stock.Symbol}, Ask: {stock.Ask}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default StockList;

import React, { useContext, useState, useEffect } from "react";
import { WebSocketContext } from "./WebSocketContext";
import StockCard from "./components/StockCard";
import "./StockList.css"; // Add CSS for the stock list
import BottomSheet from './components/BottomSheet';
import searchIcon from './assets/search.svg';
import {Search, LiveTv, CurrencyRupee} from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { Refresh } from '@mui/icons-material';
import { checkAppSession } from './utils/apiFetch';

const StockList = () => {
  const { stocks, userScripts, userDetails, lastUpdateTime, fetchUserScriptsExternal } = useContext(WebSocketContext);
  {/* <StockCard key={stock.Symbol} stock={stock} /> */}
  // const stocks = [];
  // const userScripts=[], userDetails=[], lastUpdateTime=[];
  const [showBottomSheet, setShowBottomSheet] = useState(false);
  const [selectedStock, setSelectedStock] = useState(null);
  const [filter, setFilter] = useState("MCX FUT"); // Added filter state
  const [showMoneyOptions, setShowMoneyOptions] = useState(false);
  const [showGlobalOptions, setShowGlobalOptions] = useState(false);
  const navigate = useNavigate();
  const [showTv, setShowTv] = useState(false);

  const handleNavigation = (path) => () => {
    navigate(path);
  };

  const handleToggle = () => {
    setShowTv(prevState => !prevState);
  };

  const handleCardClick = async (stock) => {
    const sessionOk = await checkAppSession();
    if (!sessionOk) {
      return;
    }

    setSelectedStock(stock);
    if(stock.exchange=="OPTSTK"){
      stock.intraday = userDetails.OPTSTK_intraday;
    } else if(stock.exchange=="FUTSTK"){
      stock.intraday = userDetails.FUTSTK_intraday;
    } else if(stock.exchange=="FUTCOM"){
      stock.intraday = userDetails.FUTCOM_intraday;
    } else if(stock.exchange=="COMEX"){
      stock.intraday = userDetails.COMEX_intraday;
    } else if(stock.exchange=="FOREX"){
      stock.intraday = userDetails.FOREX_intraday;
    } else if(stock.exchange=="GLOBAL"){
      stock.intraday = userDetails.GLOBAL_intraday;
    }
    setShowBottomSheet(true);
  };

  const handleCloseSheet = () => {
    setShowBottomSheet(false);
    setSelectedStock(null);
    // alert("closed"+showBottomSheet);
  };

  // Function to get the latest stock data for the selected stock
  const getLatestStockData = (stock) => {
    return stocks[stock.instrument_token] || {};
  };

  // Effect to update the selected stock data in the bottom sheet whenever stocks context updates
  useEffect(() => {
    if (selectedStock && selectedStock.instrument_token) {
      const latestStockData = getLatestStockData(selectedStock);
      // Only update if the stock data actually changed to prevent infinite loop
      setSelectedStock((prevStock) => {
        // Check if the live data has actually changed
        const prevLiveData = prevStock?.live || {};
        const hasChanged = JSON.stringify(prevLiveData) !== JSON.stringify(latestStockData);
        
        if (hasChanged && prevStock?.instrument_token === selectedStock.instrument_token) {
          return {
            ...prevStock,
            live: latestStockData,
          };
        }
        return prevStock;
      });
    }
  }, [stocks]); // Removed selectedStock from dependencies to prevent infinite loop

  // Filtered user scripts based on the selected filter
  const filteredUserScripts = Object.values(userScripts).filter((stock) => {
    if (filter === "MCX FUT") {
      return stock.exchange === "FUTCOM";
    } else if (filter === "NSE FUT") {
      return stock.exchange === "FUTSTK";
    } else if (filter === "NSE OPT") {
      return stock.exchange === "OPTSTK";
    } else if (filter === "COMEX") {
      return stock.exchange === "COMEX";
    } else if (filter === "FOREX") {
      return stock.exchange === "FOREX";
    } else if (filter === "GLOBAL") {
      return stock.exchange === "GLOBAL";
    }
    return true;
  });

  const handleRefresh = () => {
    fetchUserScriptsExternal();
    //alert("Refresh");
    //refreshTradesAndPortfolio("trades");
  };

  return (
    <div>
      {showTv && <div class="video-container">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/4QvoTo1CFPs?si=A2GdO2Akv5IumonS"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </div>}
      <div className="stock-page">
        <div className="header-buttons">
          <button className="refresh-button" onClick={handleRefresh}><Refresh style={{ height:'22px', color:'white' }} /></button>
          <button className="search-icon" onClick={handleNavigation('/addScript')}><Search style={{ height:'22px', color:'white' }} /></button>
          <button className="tv-icon" onClick={handleToggle}><LiveTv style={{ height:'22px', color:'white' }} /></button>
          
          {/* <div className="money-button-container">
            <button className="money-button" onClick={() => setShowMoneyOptions(!showMoneyOptions)}>
              <CurrencyRupee style={{ height:'22px', color:'white' }} />
            </button>
            {showMoneyOptions && (
              <div className="money-options">
                <button onClick={() => navigate('/deposit')}>Deposit</button>
                <button onClick={() => navigate('/withdrawal')}>Withdrawal</button>
              </div>
            )}
          </div> */}
        </div>

        {userScripts.length == 0 && <div style={{ textAlign:'center', marginTop:'100px' }}>
          Your watchlist is currently empty.<br/>Please add your desired scripts.
          <button className="search-icon_2" onClick={handleNavigation('/addScript')}>Add Script</button>
        </div>}

        {userScripts.length > 0 && <div style={{ textAlign:'center', margin:'0px auto 15px'}}>
          <div className="toggle-switch stocklist-toggle-switch" style={{ width:'258px', position:'relative'}}>
            <button  style={{ width:'auto' }} className={filter=="MCX FUT" ? 'active' : ''} onClick={() => {setFilter("MCX FUT"); setShowGlobalOptions(false);}}>MCX FUT</button>
            <button  style={{ width:'auto' }} className={filter=="NSE FUT" ? 'active' : ''} onClick={() => {setFilter("NSE FUT"); setShowGlobalOptions(false);}}>NSE FUT</button>
            <button  style={{ width:'auto' }} className={filter=="NSE OPT" ? 'active' : ''} onClick={() => {setFilter("NSE OPT"); setShowGlobalOptions(false);}}>NSE OPT</button>
            {/* <div className="global-button-container" style={{ position:'relative', display:'inline-block' }}>
              <button 
                style={{ width:'auto' }} 
                className={(filter=="COMEX" || filter=="FOREX" || filter=="GLOBAL") ? 'active' : ''} 
                onClick={() => setShowGlobalOptions(!showGlobalOptions)}
              >
                GLOBAL
              </button>
              {showGlobalOptions && (
                <div className="global-options">
                  <button 
                    className={filter=="COMEX" ? 'active' : ''} 
                    onClick={() => {setFilter("COMEX"); setShowGlobalOptions(false);}}
                  >
                    COMEX
                  </button>
                  <button 
                    className={filter=="FOREX" ? 'active' : ''} 
                    onClick={() => {setFilter("FOREX"); setShowGlobalOptions(false);}}
                  >
                    FOREX
                  </button>
                  <button 
                    className={filter=="GLOBAL" ? 'active' : ''} 
                    onClick={() => {setFilter("GLOBAL"); setShowGlobalOptions(false);}}
                  >
                    GLOBAL
                  </button>
                </div>
              )}
            </div> */}
            {/* <span className={!isLimitOrder ? 'active' : ''} onClick={handleOrderTypeToggle}>Market</span>
            <span className={isLimitOrder ? 'active' : ''} onClick={handleOrderTypeToggle}>Limit</span> */}
          </div>
        </div>}

        {filteredUserScripts.map((stock) => {
          const _stock = stocks[stock.instrument_token] || {};
          return (
            <StockCard 
              key={stock.instrumentIdentifier} 
              _stock={_stock} 
              stock={stock}
              onCardClick={handleCardClick} />
          );
        })}

        {selectedStock && <BottomSheet isOpen={showBottomSheet} onClose={handleCloseSheet} userDetails={userDetails} stock={selectedStock} />}
      </div>
    </div>
  );
};

export default StockList;
